module.exports = __webpack_public_path__ + "static/media/capa.6374602c.jpg";